import * as React from 'react'
import {useTranslation} from 'react-i18next'

const LanguageField = () => {
    const {i18n} = useTranslation()

    return <input name={'language'} type={'hidden'} value={i18n.language} />
}

export default LanguageField
